import { InkObject } from "./Object";

export class Glue extends InkObject {
  public toString() {
    return "Glue";
  }
}
